import { TIPS } from '@/mocks/kanliao';

export default function GuideTips() {
  return (
    <section id="tips" className="w-full py-12 md:py-16">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="mb-8 flex flex-col items-start gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div className="flex items-end gap-4">
            <h2 className="font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
              收藏指引
            </h2>
            <span className="mb-1 hidden h-8 w-1 rounded-full bg-secondary-500 sm:block" />
          </div>
          <p className="max-w-md text-xs leading-5 text-foreground-500 sm:text-sm">
            三步上手，把这个网址导航变成你常用的看料入口，以后想看的不用反复搜索。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
          {TIPS.map((tip, i) => (
            <div
              key={tip.title}
              className="relative flex flex-col overflow-hidden rounded-xl border border-background-200 bg-background-100 p-6 transition-colors hover:border-secondary-300"
            >
              <span className="serif-num absolute right-4 top-3 text-6xl font-black leading-none text-foreground-950/[0.05]">
                {String(i + 1).padStart(2, '0')}
              </span>
              <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-secondary-100 text-secondary-700">
                <i className={`${tip.icon} text-2xl`} />
              </span>
              <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950">{tip.title}</h3>
              <p className="mt-2 text-sm leading-6 text-foreground-600">{tip.desc}</p>
              <div className="mt-5 h-1 w-10 rounded-full bg-secondary-400/70" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}